import { useMutation } from "@tanstack/react-query";
import type { OnboardingPreferences } from "@/features/legal/types/onboarding.type";
import { updateUserLegacy } from "@/features/userProfile/services/userProfile.service";

// Saved separately from the CGU proof, through the profile endpoint the API
// leaves reachable before acceptance. Deliberately never writes the `["user"]`
// cache: that write would replay into the paused login chain. The session
// profile is refreshed once the onboarding completes.
export const useSaveOnboardingPreferences = () => {
  const mutation = useMutation({
    mutationFn: (preferences: OnboardingPreferences) => updateUserLegacy(preferences),
    // Overrides the default mutation handler: the step shows its own message.
    onError: () => undefined,
  });

  return {
    save: mutation.mutate,
    isSaving: mutation.isPending,
    hasSaveError: mutation.isError,
  };
};
